import React,{ Component } from 'react'
import { Scrollbars } from 'react-custom-scrollbars';
import { Table, Box, CssBaseline, Button, TableContainer, CardContent, Card, IconButton, Typography, TableCell, TableRow } from '@material-ui/core';
import { ArrowBackRounded } from '@material-ui/icons';
import { withStyles, makeStyles } from '@material-ui/core/styles';

const header = 65
const footer = 50
const padMarg = 60
const total = header + footer + padMarg + 10

class Layout extends Component{
    
    render(){        
        return(
            <Card style={{ minHeight: `750px`}}>
                {this.props.children}
            </Card>
        )
    }
}

export default Layout;

export class CardLayout extends Component{
    
    render(){
        return(
            <Card {...this.props}>
                {this.props.children}
            </Card>
            // <CardContent {...this.props}>
            //     {this.props.children}
            // </CardContent>
           
        )
    }
}

class CardHeader extends Component{
    
    render(){
        return(
            <Box p={2} >
                {this.props.children}
            </Box>
        )
    }
}

export class BreadCrumb extends Component {
    render(){
        return(
            <Box>
                {this.props.breadcrumb &&
                    <div>
                        <IconButton type="button" className="btn btn-default" onClick={this.props.back} color="secondary">
                            <ArrowBackRounded /> 
                        </IconButton>                    
                        <Typography variant="button" onClick={this.props.back} color="secondary">{this.props.title}</Typography>
                        <Typography variant="button"> / {this.props.breadcrumb} </Typography>
                    </div>
                }      
            </Box>
        )
    }   
}

export class ListLayout extends Component {
    state = {  }
    render() {
        const { height, width } = this.props
        return (
            <TableLayout {...this.props}>
                {this.props.children}
            </TableLayout>
        );
    }
}

export const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
  }))(TableCell);
  
export const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

export class TableLayout extends Component {
    state = {  }
    render() {
        return (
            <Box >
                {/* <CssBaseline /> */}
                <TableContainer style={this.props.style} >
                    <Table stickyHeader stripped className={this.props.className}>
                    {/* <Table style={{ whiteSpace: "nowrap" }}> */}
                        {this.props.children}
                    </Table>
                </TableContainer>
            </Box>
            // <div className="table-responsive table-layout">
            //     <table className="table table-hover dataTable table-layout">
            //         {this.props.children}
            //     </table>
            // </div>
        );
    }
}

export class ScrollLayout extends Component {
    render(){
        const { height, width } = this.props
        return (
            <Scrollbars style={{ width: (width || "100%"), height:(height || "800px" )}}>
                {this.props.children}
            </Scrollbars>
        )
    }
}

